<!-- 时间选择控件 -->
<template>
  <div class="flex">
    <div class="btn-time-box" :key="item.value" :class="timeType===item.value?'active':''" @click="changeType(item.value)"
               v-for="item in timeTypeArr">
      {{item.label}}
    </div>
    <date-picker ref="datePicker" class="ml10" @change="changeData" :disabled-type="1"></date-picker>
  </div>
</template>

<script>
  import DatePicker from "../../components/base/DatePicker";
  export default {
    props:{
      type:{
        type:Number,
        default:0
      }
    },
    name: "time-between",
    components: {DatePicker},
    data() {
      return {
        timeType:0,
        timeTypeArr:[],
      }
    },
    mixins: [tableBase],
    methods: {
      changeType(type){
        this.timeType = type;
        let start = "",end = "";
        switch (type) {
          case 0:
            //今天
            const day = new Date();
            start = day.format("yyyy-MM-dd");
            end = start;
            break;
          case 1:
            //昨天
            start = new Date(new Date().setDate(new Date().getDate() - 1)).format('yyyy-MM-dd');
            end = start;
            break;
          case 2:
            //本周
            const weekday = new Date().getDay() || 7;
            start = new Date(new Date().setDate(new Date().getDate() - weekday + 1)).format('yyyy-MM-dd');
            end = new Date(new Date().setDate(new Date().getDate() - weekday + 7)).format('yyyy-MM-dd');
            break;
          case 3:
            //本月
            start = new Date(new Date().setDate(1)).format('yyyy-MM-dd');
            end = new Date(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)).format('yyyy-MM-dd');
            break;
          case 4:
            //近7天
            start = new Date(new Date().setDate(new Date().getDate() - 7)).format('yyyy-MM-dd');
            end = new Date(new Date().setDate(new Date().getDate() - 1)).format('yyyy-MM-dd');
            break;
          case 5:
            //近30天
            start = new Date(new Date().setDate(new Date().getDate() - 30)).format('yyyy-MM-dd');
            end = new Date(new Date().setDate(new Date().getDate() - 1)).format('yyyy-MM-dd');
            break;
        }
        this.$refs.datePicker.clearTime();
        console.log([start, end]);
        this.$emit('change',[start,end]);
      },
      changeData(val){
        this.timeType = null;
        this.$emit('change',val);
      }
    },
    mounted() {
      if(this.type==0){
        this.timeTypeArr = [{label:'昨日',value:1},{label:'近7天',value:4},{label:'近30天',value:5}];
        this.changeType(1);

      }else{
        this.timeTypeArr = [{label:'本周',value:2},{label:'本月',value:3}];
        this.changeType(2);
      }

    }
  }
</script>

<style lang="less" scoped>
.btn-time-box{
  padding: 4px 10px;
  font-size: 14px;
  border: 1px solid #9e9e9e;
  font-weight: normal;
  &+.btn-time-box{
    border-left: none;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &.active,&:hover{
    background: @primary;
    color: #FFFFFF;
  }
}
</style>
